// extracted by mini-css-extract-plugin
export default {"wrapper":"adminRoles_wrapper__UpFUr"};